import styled from 'styled-components';
import Page from '@service-victoria/component-library/components/Page';
import device from '@service-victoria/component-library/utils/device';

export { Spacer16, Spacer32, Spacer48 } from '../Home/styled';

export const PageWrapper = styled(Page)``;

export const Wrapper = styled.div`
  padding: 45px 15px;
  @media ${device.isDesktop} {
    margin: 0 -32px;
    padding: 45px 50px 50px;
  }
`;
